import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      videoList: [],
      majorList: [],
      activeMajorIdx: "0",
      searchName: "",
      majorIdFromRoute: null,
      enrolledExamMap: {}
    };
  },
  created() {
    this.syncRouteMajorId();
    this.loadMajorList();
  },
  watch: {
    $route(to, from) {
      if (to.path !== "/videoCourseList") {
        return;
      }
      const toMajorId = to.query.majorId;
      const fromMajorId = from.query.majorId;
      if (toMajorId !== fromMajorId) {
        this.searchName = "";
      }
      this.syncRouteMajorId();
      this.loadMajorList();
    }
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    goStudyPage() {
      this.$router.push("/studyPage");
    },
    syncRouteMajorId() {
      const majorId = Number(this.$route.query.majorId);
      this.majorIdFromRoute =
        Number.isFinite(majorId) && majorId > 0 ? majorId : null;
    },
    async loadEnrolledExamMap() {
      this.enrolledExamMap = {};
      try {
        const res = await httpRequest(
          "/app/exam/exam/yet-enroll-exams",
          "get",
          null
        );
        if (
          res &&
          res.code === 200 &&
          Array.isArray(res.data) &&
          res.data.length > 0
        ) {
          res.data.forEach(exam => {
            const majorId = Number(exam && exam.majorId);
            if (!Number.isFinite(majorId) || majorId <= 0) {
              return;
            }
            if (!this.enrolledExamMap[majorId]) {
              this.enrolledExamMap[majorId] = exam;
            }
          });
          return;
        }
      } catch (error) {
        void error;
      }
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "-";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    getVideoExamInfo(video) {
      const majorId = Number(video && video.majorId);
      if (!Number.isFinite(majorId) || majorId <= 0) {
        return null;
      }
      return this.enrolledExamMap[majorId] || null;
    },
    isBeforeTheoryStudyStart(exam) {
      const start = this.parseDateTime(exam && exam.examStartTime);
      if (!start) {
        return false;
      }
      return Date.now() < start.getTime();
    },
    getTheoryStudyLockedMessage(exam) {
      const start = this.formatDateTime(exam && exam.examStartTime);
      const end = this.formatDateTime(exam && exam.examEndTime);
      return `暂未开启，理论学习时间：${start}~${end}`;
    },
    getVideoLockMessage(video) {
      if (!video) {
        return "课程信息异常";
      }
      if (!this.isEnrolledForVideo(video)) {
        return "请先报名对应培训班";
      }
      const exam = this.getVideoExamInfo(video);
      if (exam && this.isBeforeTheoryStudyStart(exam)) {
        return this.getTheoryStudyLockedMessage(exam);
      }
      if (
        Object.prototype.hasOwnProperty.call(video, "canBrowse") &&
        !(video.canBrowse === true || Number(video.canBrowse) === 1)
      ) {
        return exam
          ? this.getTheoryStudyLockedMessage(exam)
          : "当前课程暂不可访问";
      }
      return "";
    },
    isEnrolledForVideo(video) {
      if (!video) {
        return false;
      }
      const hasApplyField = Object.prototype.hasOwnProperty.call(
        video,
        "apply"
      );
      const hasCanBrowseField = Object.prototype.hasOwnProperty.call(
        video,
        "canBrowse"
      );
      if (hasApplyField) {
        return !!video.apply;
      }
      if (hasCanBrowseField) {
        return video.canBrowse === true || Number(video.canBrowse) === 1;
      }
      return false;
    },
    async loadMajorList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      await this.loadEnrolledExamMap();
      const res = await httpRequest("/app/major/majors", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.majorList = Array.isArray(res.data) ? res.data : [];
        const majorIdx = this.majorList.findIndex(
          item => Number(item.majorId) === Number(this.majorIdFromRoute)
        );
        this.activeMajorIdx = majorIdx >= 0 ? String(majorIdx) : "0";
        await this.loadVideoCourseList();
      } else {
        this.majorList = [];
        this.videoList = [];
      }
      loadingInstance.close();
    },
    async loadVideoCourseList() {
      const major = this.majorList[Number(this.activeMajorIdx)];
      if (!major || !major.majorId) {
        this.videoList = [];
        return;
      }

      const loadingInstance = this.$loading({ text: "加载中" });
      const params = {
        majorId: major.majorId,
        nameParam: this.searchName || ""
      };
      const res = await httpRequest("/app/course/video/courses", "get", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.videoList = Array.isArray(res.data) ? res.data : [];
      } else {
        this.videoList = [];
      }
      loadingInstance.close();
    },
    handleSearch() {
      this.loadVideoCourseList();
    },
    isVideoLocked(video) {
      return !!this.getVideoLockMessage(video);
    },
    go2VideoContentPage(video) {
      const lockMessage = this.getVideoLockMessage(video);
      if (lockMessage) {
        this.$message.warning(lockMessage);
        return;
      }
      const vcId = Number(video && video.vcId);
      const csId = Number(video && video.csId);
      if (!Number.isFinite(vcId) || vcId <= 0) {
        this.$message.warning("课程信息异常");
        return;
      }
      const query = { vcId };
      if (Number.isFinite(csId) && csId > 0) {
        query.csId = csId;
      }
      const arId = Number(video && video.apply && video.apply.arId);
      if (Number.isFinite(arId) && arId > 0) {
        query.arId = String(arId);
      }
      this.$router.push({
        path: "/videoCourse",
        query
      });
    }
  }
};
